//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
// import Logo from 'components/mixins/Logo.vue';
import Logo from 'components/templates/Logo.vue';
// import LanguageSelector from 'components/blocks/LanguageSelector.vue'
import ButtonBlock from 'components/blocks/Button.vue';
import GetStarted from 'components/combinedBlocks/GetStarted.vue'
import Hamburger from 'components/globalBlocks/Hamburger.vue'
import Navigation from 'components/globalBlocks/Navigation.vue'

export default {
  block: 'header',
    data() {
    return {
      isPageIndex: false,
      showGetStarted: false,
    }
  },
  computed: {
    ...mapGetters([
      'mobileMenuOpen',
      'getStartedMenuOpen',
    ]),
    pagePath() {
      const page = this.$route.path.split('/')[1] || '';
      return (this.isNumeric(page)) ? '/' : '/' + page;
    },
  },
  components: {
    Logo,
    // LanguageSelector,
    ButtonBlock,
    GetStarted,
    Hamburger,
    Navigation
  },
  methods: {
    ...mapMutations([
      'closeMobileMenu',
      'toggleMobileMenu',
      'openGetStartedMenu',
      'closeGetStartedMenu'
    ]),
    getIsPageIndex() {
      return this.$route.path == "/"
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    closeNavigation() {
      // Close get started and mobile menu when clicking on Spotin-logo (when navigation menu is open)
      this.closeMobileMenu();
      this.closeGetStartedMenu();
    },
  },
  watch: {
    $route() {
      this.isPageIndex = this.getIsPageIndex();
    },
  },
  mounted() {
    this.isPageIndex = this.getIsPageIndex();
  }
};



// WEBPACK FOOTER //
// ./fixed/Header.vue